/** Maps a lead status to a StatusText tone. Shared by the detail drawer and profile page. */
export function statusTone(s: string): "accent" | "value" | "warning" | "danger" | "faint" {
  if (s === "APPROVED") return "accent";
  if (s === "DUPLICATE") return "warning";
  if (s === "SUPPRESSED" || s === "REJECTED") return "danger";
  if (s === "CANDIDATE") return "faint";
  return "value";
}
